import closeSrc from "./close.svg";
import forwardSrc from "./forwardWhite.svg";
import moreSrc from "./more.svg";
import { menu } from "./style.css";

export function BackIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Back"
    >
      <path d="M19.4541 20L26 29L10 20L26 11L19.4541 20Z" />
      <path d="M26 23L23 20L26 17L29 20L26 23Z" />
    </svg>
  );
}

export function ProceedIcon() {
  return <img src={forwardSrc} alt="Proceed" />;
}

export function CloseIcon() {
  return <img src={closeSrc} alt="Close" />;
}

export function MenuIcon(props: { isOpen?: boolean }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={menu.container}
      data-open={props.isOpen}
    >
      <path
        d="M31.375 19H35.5L37 18L39 20L37 22L35.5 21H31.375L31 24H30V22L3 21L1 20L3 19L30 18V16H31L31.375 19Z"
        className={menu.sword}
      />
      <path
        d="M31.375 19H35.5L37 18L39 20L37 22L35.5 21H31.375L31 24H30V22L3 21L1 20L3 19L30 18V16H31L31.375 19Z"
        className={menu.sword}
      />
    </svg>
  );
}

export function MoreIcon() {
  return <img src={moreSrc} alt="More" />;
}
